/**
 * Environment Configuration
 * 
 * This file defines the available environments for the FPSTAK application.
 * Each environment specifies the API and Socket URLs.
 * 
 * To add a new environment:
 * 1. Add a new entry to the environments array
 * 2. Specify a unique id, display name, API URL, and Socket URL
 */

export const environments = [
  {
    id: 'local',
    name: 'Local',
    apiUrl: 'http://localhost:3001/api',
    socketUrl: 'http://localhost:3001',
  },
  {
    id: 'hosted',
    name: 'FPSTak Production',
    apiUrl: 'https://api.fpstak.gg/api',
    socketUrl: 'https://api.fpstak.gg',
  },
];

/**
 * Get the default environment
 * @returns {object} The default environment configuration
 */
export const getDefaultEnvironment = () => {
  return environments[0]; // Default to local
};

/**
 * Get environment by ID
 * @param {string} envId - The environment ID
 * @returns {object|null} The environment configuration or null if not found
 */
export const getEnvironmentById = (envId) => {
  return environments.find((env) => env.id === envId) || null;
};

/**
 * Get the currently selected environment from localStorage
 * @returns {object} The selected environment configuration
 */
export const getCurrentEnvironment = () => {
  const storedEnvId = localStorage.getItem('environment');
  if (storedEnvId) {
    const env = getEnvironmentById(storedEnvId);
    if (env) return env;
  }
  return getDefaultEnvironment();
};

/**
 * Set the current environment in localStorage
 * @param {string} envId - The environment ID to set
 */
export const setCurrentEnvironment = (envId) => {
  const env = getEnvironmentById(envId);
  if (env) {
    localStorage.setItem('environment', envId);
    return env;
  }
  throw new Error(`Environment '${envId}' not found`);
};

export default {
  environments,
  getDefaultEnvironment,
  getEnvironmentById,
  getCurrentEnvironment,
  setCurrentEnvironment,
};

